<template>
  <div>
    <b-card class="disclaimer-card">
      <div class="disclaimer-icon-wrap mb-2">
        <feather-icon icon="FileTextIcon" size="32" class="disclaimer-icon" />
      </div>
      <h3 class="disclaimer-title">{{ brandName }} Terms &amp; Conditions</h3>
      <p class="disclaimer-subtitle">Please read and agree to the following before registering for the platform.</p>

        <h3 class="mb-2">
Users of {{ brandName }}  service are bound by the following terms and conditions. By accessing or using the service you agree to these terms

        </h3>

        <h3 class="mb-2">
This document also constitutes the agreement for the Standard version of the service
        </h3>

        <div>
          <ul>
            <li class="my-1">
The FVC {{ brandName }}  service provides analysis and data on UK structured products. It service is intended for use by financial professionals and is not for private investors. Access to the service is organised by company. Each user is granted an individual login that is not to be transferred or shared
            </li>

            <li class="my-1">
Company subscriptions are divided into Standard and Premium. Standard access is granted free of charge at our discretion generally only to financial adviser firms. Premium access is a paid subscription service agreed between an authorised representative of the company and FVC. Use of the Premium service is covered by a signed agreement between the company and FVC. Details can be found <router-link :to="{name: 'privacy-policy'}">  here      </router-link>.
We reserve the right to alter or terminate the Standard service at any time
                   </li>
     <li class="my-1">
Unless expressly permitted by FVC  all content and data is for use by for the individual subscriber only. No content or data from this service should be shared externally to another person or company without prior written agreement from FVC. Users must not attempt to gain unauthorised access to any part of the service or use automated processes, scraping, data extraction or similar methods to systematically download or reproduce content or data without FVC's prior written consent
                  </li>
      <li class="my-1">
FVC does not undertake to provide any service or to cover all and every relevant product on the {{ brandName }}  service. The service is offered as is and we do not undertake to enter into any discussion about content or data
                      </li>
  <li class="my-1">
This service is not available for private investors who should seek the advice of an authorised Independent Financial Adviser or otherwise qualified professional in their jurisdiction. The {{ brandName }}  service is intended to be used by financial professionals as part of their product selection, analysis, research and compliance processes
                      </li>
  <li class="my-1">
This service is for informational and analytical purposes only. It does not constitute, and should not be construed as: investment advice or a personal recommendation; an offer, solicitation or recommendation to buy, sell, subscribe for, or otherwise deal in any security, structured product or financial instrument; or a substitute for a subscriber's own due diligence, professional judgement, or regulatory obligations (including, where applicable, suitability or appropriateness assessments owed to end clients)

                    </li>
    <li class="my-1">
{{ brandName }}  must not be used in any way which could damage, disrupt or interfere with the operation or security of the service

               </li>
         <li class="my-1">
We accept absolutely no responsibility for the use of this service by any user who retains all responsibility for the use, interpretation or assumptions about any material contained in this service. No liability whatsoever is accepted for any loss or expense incurred from using any part of this service and no part of the contents of this service constitutes advice nor should it be relied upon for any purpose
                    </li>
    <li class="my-1">
All intellectual property rights in {{ brandName }} , including the website, reports, analysis, methodologies, calculations, data presentation, design and other content produced by FVC, are owned by or licensed to FVC. Access to the service does not transfer any ownership rights to the user or subscribing company
                      </li>
  <li class="my-1">
We reserve the right to decline or terminate access of any user to the service without notice or reason or to otherwise change the terms of this service.
                   </li>
     <li class="my-1">
In order to ensure a user is kept up to date on the structured product market, emails regarding new products and relevant matters will be sent to all users. You can change your email preferences in the account section of the website.
FVC may send users communications as is necessary for the operation and administration of the {{ brandName }}  service
            <li class="my-1">
A user can terminate their account at any time. Personal data associated with an account will be handled in accordance with FVC's <router-link :to="{name: 'privacy-policy'}">  Privacy Policy      </router-link> and applicable data protection legislation, including any legal or regulatory requirements relating to the retention of information.
Usage of the service is also subject to our <router-link :to="{name: 'privacy-policy'}">  Privacy Policy      </router-link>
</li>

            <li class="my-1">
FVC is not authorised or regulated by the Financial Conduct Authority. Structured Edge does not constitute regulated investment advice, and subscribers who are themselves regulated firms remain solely responsible for their own regulatory compliance, including any advice given to their own clients
</li>
            <li class="my-1">
These terms, and any dispute or claim arising out of or in connection with them or Structured Edge (including non-contractual disputes or claims), are governed by and construed in accordance with the laws of England and Wales. The courts of England and Wales shall have exclusive jurisdiction
</li>

          </ul>
        </div>

      <div class="disclaimer-body">
        <p class="mb-0">
          By clicking <strong>I Agree</strong>, you confirm that you have read, understood, and accept these terms.
        </p>
      </div>

      <div class="disclaimer-actions">
        <b-button variant="outline-secondary" @click="termsRejected">
          I Disagree
        </b-button>
        <b-button variant="primary" @click="termsAccepted">
          I Agree
        </b-button>
      </div>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import { $themeConfig } from '@themeConfig'

export default {
  components: {
    BCard,
    BButton,
  },
  computed: {
    brandName() {
      return this.brand === 'se' ? 'Structured Edge' : 'Future Value Consultants'
    },
    brand() {
      return $themeConfig.app.brand
    },
  },
  methods: {
    termsRejected() {
      this.$router.push('/')
    },
    termsAccepted() {
      this.$emit('agreed')
    },
  },
}
</script>

<style scoped>
.disclaimer-card {
  max-width: 700px;
  margin: 0 auto;
}

.disclaimer-icon-wrap {
  display: flex;
  justify-content: center;
}

.disclaimer-icon {
  color: var(--primary);
}

.disclaimer-title {
  text-align: center;
  font-size: 1.375rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
}

.disclaimer-subtitle {
  text-align: center;
  margin-bottom: 1.5rem;
  font-size: 0.9rem;
}

.disclaimer-body {
  background: #f8f8f8;
  border: 1px solid #ebe9f1;
  border-radius: 6px;
  padding: 1.25rem 1.5rem;
  font-size: 0.875rem;
  line-height: 1.7;
  max-height: 260px;
  overflow-y: auto;
  margin-bottom: 1.75rem;
}

.disclaimer-body p + p {
  margin-top: 0.75rem;
}

.disclaimer-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
}
</style>
